import React from 'react'
import { ProductListByIds } from '@dustin-web/product-components/src/product-list-by-ids'
import { MacroProps } from './macro-props'
import { getCommaSeparatedStrings } from './macro-parameter-extractor'

export const Productbox = (props: MacroProps) => {
  const productIds = getCommaSeparatedStrings('productid', props)
  // Html.RenderAction("RenderProductBoxes", "Search", new { productIds, preserveProductOrder = true, containerWidth = 12 });
  return productIds ? (
    <ProductListByIds
      productErpIdentifiers={productIds}
      listType={'gallery'}
      digitalDataOrigin="contentMacro"
      oneProductOnly
    />
  ) : null
}

export default Productbox
